<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Requests</h2>
  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'project_id'">Anfrage</clr-dg-column>
    <clr-dg-column [clrDgField]="'project_name'">Projektname</clr-dg-column>
    <clr-dg-column [clrDgField]="'requests_company'">Anfrage an</clr-dg-column>
    <clr-dg-column [clrDgField]="'subject'">Beschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'purchasing_id'">Angebotsnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'requests_date'" [clrDgSortOrder]="descSort">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'requests_submit'">Fälligkeit</clr-dg-column>
    <clr-dg-column [clrDgField]="'purchasing_price'" class="currency">Summe (netto)</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Request!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let request of requests">
      <clr-dg-cell [routerLink]="['/request/details', request.project_id, request.request_id]">{{ request.project_id }}.0001.{{ request.request_id }}</clr-dg-cell>
      <clr-dg-cell><b>{{ request.project_name }}</b></clr-dg-cell>
      <clr-dg-cell [routerLink]="['/request/details', request.project_id, request.request_id]">{{ request.requests_company }}<br />({{ request.requests_salutation}} {{ request.requests_firstname }} {{ request.requests_lastname}})</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/request/details', request.project_id, request.request_id]">{{ request.subject }}</clr-dg-cell>
      <clr-dg-cell>{{ request.purchasing_id }}</clr-dg-cell>
      <clr-dg-cell>{{ request.requests_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell>{{ request.requests_submit | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell class="currency"><b>{{ request.purchasing_price | currency: 'EUR':'code':'1.2-2':'de'  }}</b></clr-dg-cell>
      <clr-dg-cell  [className]="findButtonClass(request.status)" role="alert">
        <div class="alert-items">
          <div class="alert-item static">
            <span class="alert-text">{{ getCellStatus(request.status).statusDisplay}}</span>
          </div>
        </div>
      </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Anfragen pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{requests.length}} Anfrage(n)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
